var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14108 30C2.29731 30 1.56304 29.6876 0.938273 29.0629C0.312758 28.4381 0 27.7038 0 26.86V3.13995C0 2.29618 0.312758 1.56191 0.938273 0.937149C1.56304 0.312383 2.29731 0 3.14108 0H26.86C27.7038 0 28.4385 0.312383 29.064 0.937149C29.6887 1.56191 30.0011 2.29618 30.0011 3.13995V12.6566L37.5017 5.156V24.844L30.0011 17.3434V26.86C30.0011 27.7038 29.6887 28.4381 29.064 29.0629C28.4385 29.6876 27.7038 30 26.86 30H3.14108Z",
    fill: "#133F7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamBlue);
export default __webpack_public_path__ + "static/media/video-cam-blue.c959dba219c81855584c38ffe5dc9544.svg";
export { ForwardRef as ReactComponent };